<script setup>
import { RouterView } from 'vue-router'
</script>

<template>
    <div class="page page--auth">
        <div class="page__wrapper">
            <RouterView></RouterView>
        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/views/auth';
</style>